var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#002346","strokeWidth":"1.231"},React.createElement("g",{"transform":"translate(-289.000000, -1773.000000) translate(289.000000, 1773.000000)"},[React.createElement("circle",{"cx":"16","cy":"16","r":"15.385","key":0}),React.createElement("path",{"d":"M7.586 11.54L16.983 21.489 24.336 14.369","transform":"translate(15.960733, 16.514483) scale(-1, 1) translate(-15.960733, -16.514483)","key":1})]))));
}

CheckInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
